import { checkEmailAddressUnique } from '@ukpostbox/client-data';
import { EmailControl, FormWrapperLabel, useDebounce } from '@ukpostbox/frontend-framework';
import { ControllerFieldState } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect, useRef, useState } from 'react';

type UniqueEmailControlType = {
	name: string;
	label: string;
	defaultValue: string;
	placeholder: string;
	changeCallback: (value: string) => void;
	lookupActiveCallback: (state: boolean) => void;
	validationCallback: (message: string, resetErrors: boolean) => void;
	fieldState?: ControllerFieldState;
};

function UniqueEmailControl(props: UniqueEmailControlType) {
	const [emailValid, setEmailValid] = useState<boolean>(false);
	const [lookupActive, setLookupActive] = useState<boolean>(false);
	const emailValueRef = useRef<string>(props.defaultValue);
	const emailDebounceValue = useDebounce(emailValueRef.current, emailValid ? 1000 : 0);
	const emailInputRef = useRef<HTMLInputElement>(null);

	const HandleChange = (e: string, validState: boolean) => {
		emailValueRef.current = e;
		setEmailValid(validState);
		props.changeCallback(e);
	};

	const CheckUniqueEmail = (value: string) => {
		if (!emailValid) return;

		setLookupActive(true);
		props.lookupActiveCallback(true);

		checkEmailAddressUnique(value)
			.then((r: { isUnique: boolean }) => {
				props.validationCallback('E-mail address is already in use', r.isUnique);
			})
			.catch((e: any) => {
				props.validationCallback(`Something went wrong ${e}`, false);
			})
			.finally(() => {
				setLookupActive(false);

				props.lookupActiveCallback(false);
				setTimeout(() => {
					if (emailInputRef.current) {
						emailInputRef.current.focus();
					}
				}, 50);
			});
	};

	useEffect(() => {
		if (emailDebounceValue?.debouncedValue && emailDebounceValue.debouncedValue !== '') {
			CheckUniqueEmail(emailDebounceValue.debouncedValue);
		}
	}, [emailDebounceValue.debouncedValue]);

	return (
		<FormWrapperLabel
			label={props.label}
			invalid={props.fieldState?.invalid}
			validationMessage={props.fieldState?.error?.message}
			active={lookupActive}
			showValidationMarks
		>
			<EmailControl
				ref={emailInputRef}
				name={props.name}
				defaultValue={props.defaultValue}
				placeholder={props.placeholder}
				disabled={lookupActive}
				onChangeCallback={(e, validState) => HandleChange(e, validState)}
			/>
		</FormWrapperLabel>
	);
}

export { UniqueEmailControl };
